import { z } from "zod";
import {
  SocialApplicationStatus,
  SocialCreatorType,
  SocialGender,
} from "../../types/models/social.models.types";
// import { PostStatus } from "../../types/models/post.models.types";

export const zCommunicationFormAdmin = z.object({
  title: z.string().min(1, { message: "Title is required" }),
  description: z.string().min(1, { message: "Description is required" }),
  notificationType: z
    .string()
    .min(1, { message: "Notification Type is required" }),
  filters: z
    .object({
      socials: z.object({
        creatorType: z.array(z.nativeEnum(SocialCreatorType)).default([]),
        genderPreference: z.array(z.nativeEnum(SocialGender)).default([]),
        applicationStatus: z.array(z.nativeEnum(SocialApplicationStatus)).default([]),
      }),
      // campaign: z.object({
      //   campaignId: z.string().min(1, { message: "Campaign Id is required" }),
      //   postStatus: z.array(z.nativeEnum(PostStatus)).default([]),
      // }),
    })

});

export type IzCommunicationFormAdmin = z.infer<typeof zCommunicationFormAdmin>;
